export const TOAST_DURATION = 3000;
export const MODAL_SIZE_3_XL = "3xl";
export const MODAL_SIZE_XL = "xl";
export const INTERNAL_EMAIL_DOMAIN = "alvarezandmarsal.com";
export const ALLOWED_LOGO_EXTENSIONS = ["png", "svg", "jpg", "jpeg", "svg+xml"];
export const ALLOWED_BULK_UPLOAD_EXTENSIONS = ["xlsx"];
export const ALLOWED_DIAGRAM_EXTENSIONS = ["png", "svg", "jpg", "jpeg", "svg+xml"];
export const MODAL_SIZING = { base: "full", sm: "lg", md: "xl", lg: "2xl", xl: "3xl" };
export const MODAL_CONTENT_SIZING = { maxWidth: "60vw", maxHeight: "95vh" };
export const DELETE_MODAL_SIZING = { maxWidth: "35vw", maxHeight: "95vh" };
export const ALLOWED_BENCHMARK_EXTENSIONS = ["xlsx"];
export const ALLOWED_JURISDICTION_OVERVIEW_EXTENSIONS = ["docx"];

// Headcount limit
export const MAX_HEADCOUNT = 8000000000;

// Transaction limits
export const MIN_TRANSACTIONS = 1;
export const MAX_TRANSACTIONS = 20;

// Lead MD list
export const LEADMD_LIST = [
    "Panhwar, Shahzeb",
    "Syratt, Richard",
    "Khan, Imran",
    "De Felice, Matthew",
    "Alms, Marc",
    "Trahan, Sean",
    "Peters, Dan",
    "Sharma, Vishal",
    "Whitehouse, Justin",
    "Arman, Pierre",
];

// Routes
export const ROUTE_404 = "/404";
